module.exports = __webpack_public_path__ + "img/growcify-website-13-banner.c7a5e887.png";